module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="sidebar right">\r\n\t<div class="fixedheader">\r\n\t\t<div class="top">\r\n\t\t\t<span class="icon"><img src="' + require("D:\\Marco\\Dropbox (ISI Foundation)\\2016 - ISI\\grantorino\\frontend\\node_modules\\underscore-template-loader\\file-loader.js?url=%2Fimg%2Farchive.svg!D:\\Marco\\Dropbox (ISI Foundation)\\2016 - ISI\\grantorino\\frontend\\src/img/archive.svg") + '">'+
((__t=( sectionTitle ))==null?'':__t)+
'</span>\r\n\t\t\t<span class="backlink">'+
((__t=( projectTitle ))==null?'':__t)+
'</span>\r\n\t\t</div>\r\n\t</div>\r\n\t<div class="header">\r\n\t\t<div class="top">\r\n\t\t\t<span class="icon"><img src="' + require("D:\\Marco\\Dropbox (ISI Foundation)\\2016 - ISI\\grantorino\\frontend\\node_modules\\underscore-template-loader\\file-loader.js?url=%2Fimg%2Farchive.svg!D:\\Marco\\Dropbox (ISI Foundation)\\2016 - ISI\\grantorino\\frontend\\src/img/archive.svg") + '">'+
((__t=( sectionTitle ))==null?'':__t)+
'</span>\r\n\t\t\t<span class="backlink">'+
((__t=( projectTitle ))==null?'':__t)+
'</span>\r\n\t\t</div>\r\n\t\t<h1>'+
((__t=( sectionLongTitle ))==null?'':__t)+
'</h1>\r\n\t</div>\r\n\t<div class="contents">\r\n\t</div>\r\n</div>';
}
return __p;
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/js/views/sidebar/sidebar.tmpl
 ** module id = 30
 ** module chunks = 0
 **/